import { fabric } from 'fabric';
import { FABRIC_CUSTOM_OBJECT } from '../../../utils';

export function createControlRectWithText(e) {
  const { target } = e;
  const { left, top, width, height } = target;
  const { canvas } = window;
  const options = JSON.parse(JSON.stringify(target.textStyle));
  const textBox = new fabric.Textbox(options.text, {
    ...options,
    name: FABRIC_CUSTOM_OBJECT.textRectWithText,
    lockMovementX: true,
    lockMovementY: true,
    hasControls: false,
    isNotObj: true,
    parentObj: target,
    borderColor: 'blue',
    objectCaching: false,
    borderScaleFactor: 2,
    left: left + width / 2 + options.left + target.strokeWidth / 2,
    top: top + height / 2 + options.top + target.strokeWidth / 2,
  });
  target.set({ clipPath: null, textStyle: { ...target.textStyle, text: '' } });
  canvas.add(textBox);
  canvas.setActiveObject(textBox);
  textBox.enterEditing();
  textBox.hiddenTextarea.focus();
  textBox.selectAll();
  return true;
}

export function controlRectWithTextModified(e) {
  const target = e;
  if (target.parentObj.textStyle.textAlign !== target.textAlign) {
    target.parentObj.set({
      textStyle: {
        ...target.parentObj.textStyle,
        textAlign: target.textAlign,
      },
    });
    target.parentObj.updateTextStyle();
    const myRect = target.parentObj;
    target.set({
      left: myRect.left + myRect.width / 2 + myRect.textStyle.left + myRect.strokeWidth / 2,
      top: myRect.top + myRect.height / 2 + myRect.textStyle.top + myRect.strokeWidth / 2,
      originX: myRect.textStyle.originX,
      originY: myRect.textStyle.originY,
      textAlign: myRect.textStyle.textAlign,
    });
    const { canvas } = window;
    target.setCoords();
    canvas.remove(target);
    canvas.add(target);
    canvas.setActiveObject(target);
  }
  return true;
}

export function controlRectWithTextRemove(target) {
  const { canvas } = window;
  const parentObj = canvas.getObjects().find((o) => o.id === target.parentObj.id);
  const options = JSON.parse(JSON.stringify(target));
  parentObj.set({ clipPath: null, textStyle: options });
  canvas.remove(target);
  return true;
}
